module.exports = __webpack_public_path__ + "static/media/ios-stopwatch.7e7e588e.svg";